import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { LocalStorageService, SessionStorageService } from 'ngx-webstorage';
import { CookieService } from 'ngx-cookie-service';

import { CoreConfigService } from '../config/core-config.service';
import { Principal } from './principal.service';

@Injectable({ providedIn:'root' })
export class AuthServerProvider {
    constructor(
        private http: HttpClient,
        private configService: CoreConfigService,
        private principal: Principal,
        private localStorage: LocalStorageService,
        private sessionStorage: SessionStorageService,
        private cookieService: CookieService
    ) {}

    get domainPath(){
        return this.configService.cookiePathMode == 'PATH' ? window.location.pathname : '/';
    }
   
    getToken() {
        const accessToken = this.localStorage.retrieve('authenticationToken') || this.sessionStorage.retrieve('authenticationToken');
        if(accessToken && !this.cookieService.get("access_token")){
            const refreshToken = this.localStorage.retrieve('authenticationRefreshToken') || this.sessionStorage.retrieve('authenticationRefreshToken');
            this.setCookieToken(accessToken, refreshToken);
        }
        return accessToken;
    }

    login(credentials): Observable<any> {
        let data = null;
        if (credentials.grant_type === 'open_auth') {
            data = `grant_type=${encodeURIComponent(credentials.grant_type)}`
            + `&action=${encodeURIComponent(credentials.action)}`
            +`&auth_temp_key=${encodeURIComponent(credentials.auth_temp_key)}`
            + `&auth_type=${encodeURIComponent(credentials.auth_type)}`
            +`&code=${encodeURIComponent(credentials.code)}`;
        } else {
            credentials.username = credentials.username.trim(); // 去除空格
            credentials.password = credentials.password.trim(); // 去除空格
            data = `username=${encodeURIComponent(credentials.username)}`
            + `&password=${encodeURIComponent(credentials.password)}`
            + `&rememberMe=${!!credentials.rememberMe}&grant_type=password`;
        }

        const headers = new HttpHeaders({ 
            'Content-Type': 'application/x-www-form-urlencoded', 
            'Authorization': 'Basic d2ViX2FwcDo=' 
        });
        this.clearAuthenticationToken();
        return this.http.post(this.configService.apiUrls.oauthToken, data, { 'headers': headers, observe: 'response' })
            .pipe(map(resp => {
                const bearerToken = resp.headers.get('Authorization');
                const accessToken = resp.body['access_token'];
                const refreshToken = resp.body['refresh_token'];
                const userId = resp.body['user_id'];
                if(userId) this.principal.authenticatedUserId = userId;
                if (accessToken) {
                    this.storeAuthenticationToken(accessToken, refreshToken, credentials.rememberMe);
                }else if (bearerToken && bearerToken.slice(0, 7) === 'Bearer ') {
                    const jwt = bearerToken.slice(7, bearerToken.length);
                    this.storeAuthenticationToken(jwt, refreshToken, credentials.rememberMe);
                    return jwt;
                }
            }));
    }

    loginWithToken(accessToken, rememberMe) {
        if (accessToken) {
            this.storeAuthenticationToken(accessToken, null, rememberMe);
            return Promise.resolve(accessToken);
        } else {
            return Promise.reject('auth-jwt-service Promise reject'); // Put appropriate error message here
        }
    }

    storeAuthenticationToken(accessToken, refreshToken, rememberMe) {
        if (rememberMe) {
            this.sessionStorage.clear('authenticationToken');
            this.sessionStorage.clear('authenticationRefreshToken');
            this.localStorage.store('authenticationToken', accessToken);
            // this.localStorage.store('authenticationRefreshToken', refreshToken);
        } else {
            this.localStorage.clear('authenticationToken');
            this.localStorage.clear('authenticationRefreshToken');
            this.sessionStorage.store('authenticationToken', accessToken);
            // this.sessionStorage.store('authenticationRefreshToken', refreshToken);
        }
        // console.log(jwt);
        this.setCookieToken(accessToken, refreshToken);
    }
    private setCookieToken(accessToken, refreshToken){
        if(this.configService.requestAuthMode == 'COOKIE'){
            if(accessToken) this.cookieService.set("access_token", accessToken, null, this.domainPath);
            else this.cookieService.delete('access_token', this.domainPath);

            if(refreshToken) this.cookieService.set("refresh_token", refreshToken, null, this.domainPath);
            else this.cookieService.delete('refresh_token', this.domainPath);
        }
        this.cookieService.set('crx_token', accessToken,  null, this.domainPath);
    }

    clearAuthenticationToken(){
        this.localStorage.clear('authenticationToken');
        this.localStorage.clear('authenticationRefreshToken');
        this.sessionStorage.clear('authenticationToken');
        this.sessionStorage.clear('authenticationRefreshToken');
        this.cookieService.delete('access_token', this.domainPath);
        this.cookieService.delete('refresh_token', this.domainPath);
        this.cookieService.delete('crx_token', this.domainPath);
    }

    logout(): Observable<any> {
        return new Observable((observer) => {
            this.principal.authenticate(null);
            this.clearAuthenticationToken();
            observer.complete();
        });
    }
}
